var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaxTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bb4936d8-0e0e-437a-a5e8-7b5629a6d0c4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5,11.2L4.1,6.6l0,0c0.1,0.9,0.1,1.5,0.1,1.9v2.7H3V5.4h1.7l1.4,4.4l0,0l1.5-4.4h1.7v5.8H8.1V8.4c0-0.1,0-0.3,0-0.4 c0-0.2,0-0.6,0.1-1.4l0,0l-1.5,4.6C6.7,11.2,5.5,11.2,5.5,11.2z M14.2,11.2l-0.4-1.4h-2.1l-0.4,1.4H9.9L12,5.4h1.5l2.1,5.8 C15.6,11.2,14.2,11.2,14.2,11.2z M13.5,8.8c-0.4-1.3-0.6-2-0.7-2.1c0-0.2-0.1-0.3-0.1-0.4c-0.1,0.3-0.3,1.2-0.8,2.5H13.5z M21,11.2 h-1.4L18.2,9l-1.4,2.2h-1.3l1.9-3l-1.8-2.8H17l1.3,2.1l1.2-2.1h1.3L19,8.3L21,11.2z M5.7,18.6H4.5v-4.5H3v-1h4.2v1H5.7V18.6z  M8,18.6v-5.5h1.2v5.5H8z M12.9,18.6l-1.3-4.3h0c0,0.9,0.1,1.5,0.1,1.8v2.6h-1v-5.5h1.6l1.3,4.2h0l1.4-4.2h1.6v5.5h-1.1V16 c0-0.1,0-0.3,0-0.4c0-0.2,0-0.6,0.1-1.3h0L14,18.6H12.9z M21,18.6h-3.2v-5.5H21v1h-2v1.2h1.9v1H19v1.4h2V18.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxTime);
export default __webpack_public_path__ + "static/media/max_time.d0224d02.svg";
export { ForwardRef as ReactComponent };